module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_intro",
    attrs: {
      "epub:type": "introduction"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('div', {
    staticClass: "enc2"
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "auteur"
  }, [_c('span', [_vm._v("SCOTT M. MANETSCH")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROTESTANT")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFORMATION OF THE SIXTEENTH")]), _vm._v(" century had many different faces and many surprising features. It was a constellation of social events that changed how people related to their families and communities, ushering in wide-ranging reforms in education, poverty relief, marriage and divorce, the clerical office, and social discipline. The Reformation was also a collection of political events that empowered rulers to extend authority over their subjects while at the same time fragmenting the German-speaking world into rival confessional groups that delayed the unification of Germany for more than three hundred years. In addition, the Reformation was a cluster of revolutionary events that crystalized and intensified widespread discontent against the received feudal agrarian system, a social protest that exploded in the German Peasants’ War of 1525. And, certainly, the Reformation was a mass media event as Martin Luther and other Protestant leaders harnessed new print technologies to articulate their evangelical message and dismantle traditional religious institutions and customs.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("While each of these features is important, they fail to capture what the Protestant reformers themselves understood to be the substance and essential core of the sixteenth-century Reformation. For early Protestant leaders such as Martin Luther, Huldrych Zwingli, Nicholas Ridley, John "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("Knox, and John Calvin, the Reformation was a religious renewal movement that called the church back to the Scriptures and the centrality of the Christian gospel. The Reformation was not first and foremost about changing the social or political order but rather about recovering from Scripture the central message of Christianity—that God extends grace to sinners who trust in Jesus Christ alone—and applying that theological insight to the spiritual needs of men and women as well as the practical concerns of church and community. In their view, the Protestant Reformation was a divinely orchestrated "), _c('i', [_vm._v("religious ")]), _vm._v("or "), _c('i', [_vm._v("spiritual ")]), _vm._v("event that found its origin in the recovery, reading, and faithful application of the Bible.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Both the literature and lived experience of early Protestants provide ample testimony to these primary religious concerns. One striking example is seen in Martin Luther’s “Exhortation to the Clergy Assembled at the Diet at Augsburg,” written by the Reformer in May of 1530 from the safety of Coburg Castle as he anxiously awaited updates from the imperial diet."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#ntb-001",
      "id": "ap_ntb-001-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" In this largely forgotten treatise—which has been called Luther’s own Augsburg Confession—the Saxon Reformer offered a general assessment of the progress of evangelical teaching, showing “what great and glorious fruit the word of God has produced” and “what the world would be like if our gospel had not come.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#ntb-002",
      "id": "ap_ntb-002-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Luther described in graphic detail the state of medieval Catholic religion without the Reformation: the “unspeakable thievery” of indulgences, the “hellish” sacrament of penance, the travesty of clerical celibacy, the “scandalous huckstering” of endowed masses, the “false and shameful” devotion shown Mary and the saints, the patent failure of episcopal leadership, and the shocking ignorance of the parish clergy."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#ntb-003",
      "id": "ap_ntb-003-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Through these abuses the medieval church had detracted from Christ’s unique sacrifice for sins, tortured the consciences of God’s people, encouraged blatant idolatry, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_vm._v("championed works righteousness, and condemned faithful Christians to death as heretics. All these errors and abuses, Luther believed, had resulted from the fact that the traditional church had elevated its theologians and traditions above God’s holy Word. Luther commented:")])]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Their best work, however, was in despising the Holy Scriptures, and letting them lie under the bench! “Bible, Bible?” said they. “The Bible is a heretics’ book! You must read the doctors! There you find what is what!” I know that I am not lying about this, for I grew up among them and have heard and seen all this from them."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#ntb-004",
      "id": "ap_ntb-004-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("From Luther’s perspective, then, the central contribution of the Protestant Reformation was to restore to their rightful place in Christ’s church the Scriptures and the “free and pure gospel” (what later Protestants called the formal and material principles of the Reformation)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#ntb-005",
      "id": "ap_ntb-005-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" This was what set the Lutherans apart from their Catholic opponents, the Reformer believed: “You and we know that you live without God’s word, but we have God’s word. . . . We ask nothing more, and never have asked anything more, than that the gospel shall be free.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#ntb-006",
      "id": "ap_ntb-006-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" Armed with God’s Word and God’s gospel, Lutheran preachers now served as agents for spiritual renewal as they dismantled the numerous Catholic errors and superstitions and provided true Christian consolation to the souls of those in despair. Previously, Luther noted,")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("No one knew how to preach the gospel otherwise than to teach out of it examples of good works, and no one of us ever heard a gospel that aimed to give comfort to the conscience and to lead to faith and trust in Christ. That is how it ought to be preached, and, praise God! it is now preached that way again."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#ntb-007",
      "id": "ap_ntb-007-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In the final paragraphs of his “Exhortation,” Luther identified 114 additional unbiblical customs and doctrines taught by the Roman Church—ranging from Lenten fasts to kissing and adoring the cross—and he "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_vm._v("urged the clergy at the Diet of Augsburg to reform the church in light of the message of Scripture. “The true Church,” he insisted, “must be the one that holds to God’s Word and suffers for it, as, praise God! we do, and murders no one and leads no one away from God’s Word. . . . God help you to a reformation on this point!”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#ntb-008",
      "id": "ap_ntb-008-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("While Martin Luther anxiously awaited reports from the Diet of Augsburg during the late spring and summer of 1530, he entertained a steady stream of friends and curious visitors to Coburg Castle who sought his audience and advice. One of these visitors was a remarkable woman named Argula (von Stauff) von Grumbach, whose life experience reflected the deep religious convictions that motivated many early Protestants. Born around 1492 into a distinguished German noble family near Beratzhausen in Bavaria, Argula was raised by pious parents who taught her to pray and to read the German Bible, a copy of which her father gave her as a gift on her tenth birthday. As a young woman of fifteen or sixteen, she was sent to the imperial court in Munich, where she served as a lady-in-waiting to Queen Kunigunde (daughter of Emperor Frederick III)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#ntb-009",
      "id": "ap_ntb-009-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" Around 1516, she married Friedrich von Grumbach, and the couple soon settled in the town of Dietfort, near Ingolstadt. Though it is uncertain when or how Argula von Grumbach first came into contact with Luther’s ideas, it is clear that by the early 1520s she had become a supporter of the Wittenberg theology and was avidly studying Luther’s writings in light of Scripture—much to her husband Friedrich’s displeasure. What began as private religious conviction erupted into public controversy in 1523 when Argula defied cultural norms and her husband’s wishes by writing a blistering letter to the University of Ingolstadt, protesting the harsh treatment shown to a young student named Arsacius Seehofer, who had been forced by the theological faculty to recant his evangelical beliefs."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#ntb-010",
      "id": "ap_ntb-010-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Among the doctrines that Seehofer had "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_vm._v("disavowed under duress were Luther’s teachings on justification by grace alone through faith alone and Scripture’s supreme authority over the church."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#ntb-011",
      "id": "ap_ntb-011-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Argula von Grumbach’s letter to the University of Ingolstadt, which subsequently appeared in sixteen printed editions, was courageous, passionate, and brutally frank, reflecting her confident command of Scripture and deep spiritual conviction. In this long letter, Argula quoted no fewer than seventy biblical texts, many, it seems, from memory. In the opening lines of her letter, Argula addressed the obvious question that would have troubled most of her readers: What gave her license, as a woman with no university training, to confront and correct learned theologians of the church? She argued that it was Scripture itself that gave her this right, for Christ’s statement in Matthew 10:32 (“So everyone who acknowledges me before men, I also will acknowledge before my Father who is in heaven”) and the prophetic command in Ezekiel 33 (“If you see your brother sin, reprove him”) applied to all Christians regardless of gender or educational background."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#ntb-012",
      "id": "ap_ntb-012-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Hence, in obedience to these divine commands, Argula felt compelled to set forth her confession of faith and, at the same time, reprove the Catholic theologians at Ingolstadt for their gross neglect of God’s Word. Argula presented herself as well-studied in the religious controversies of her day. Several years earlier, she had disregarded the warnings of Franciscan monks and begun reading the German Bible for herself, a practice that provided rich spiritual illumination and soon reshaped her theological convictions. “Ah, but what joy it is when the Spirit of God teaches and gives us understanding, flitting from one text to the next—God be praised—so that I came to see the true, genuine light shining out.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#ntb-013",
      "id": "ap_ntb-013-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("At the same time, as she read Luther’s writings and compared them with his German New Testament, she became convinced that the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_vm._v("Wittenberg theology accorded with the teachings of the Bible. “For my part,” she wrote, “I have to confess, in the name of God and by my soul’s salvation, that if I were to deny Luther and Melanchthon’s writing I would be denying God and his word, which may God forfend forever.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#ntb-014",
      "id": "ap_ntb-014-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" The theologians of Ingolstadt, by contrast, had condemned Luther’s teaching and declared him a heretic without even consulting Scripture. Indeed, these reputed doctors of the church were completely ignorant of the teachings of the Bible and thus had to resort to threats and coercion rather than godly persuasion."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#ntb-015",
      "id": "ap_ntb-015-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" “I beseech you for the sake of God,” Argula demanded, “tell me in writing which of the articles written by Martin or Melanchthon you consider heretical. In German not a single one seems heretical to me.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#ntb-016",
      "id": "ap_ntb-016-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" Argula’s belief that Scripture should have supreme authority for defining Christian doctrine and practice echoed the conviction of Luther and other evangelical Reformers. As she put it, “No one has a right to exercise sovereignty over the word of God. . . . For the word of God alone—without which nothing was made—should and must rule.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#ntb-017",
      "id": "ap_ntb-017-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" At the conclusion of her letter, Argula von Grumbach struck the pose of a modern-day prophet as she confidently announced God’s Word to the Catholic theologians at Ingolstadt. “What I have written to you is no woman’s chit-chat, but the word of God; and (I write) as a member of the Christian Church, against which the gates of Hell cannot prevail. . . . God give us his grace that we all may be saved.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#ntb-018",
      "id": "ap_ntb-018-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Both Martin Luther’s “Exhortation” to the clergy at the Diet of Augsburg and Argula von Grumbach’s letter to the faculty at the University of Ingolstadt illustrate particularly well the significant impact that Scripture had in shaping the theological convictions and spiritual experiences of "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_vm._v("men and women in the sixteenth century. The eminent Reformation scholar G. R. Elton in the early 1960s lent support to this view, noting that “if there is a single thread running through the whole story of the Reformation, it is the explosive and renovating and often disintegrating effect of the Bible.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#ntb-019",
      "id": "ap_ntb-019-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" In the past half-century, however, this perspective has fallen out of favor with many social and cultural historians, who, being suspicious of traditional confessional narratives of the Reformation, have focused instead on (what they see as) the primary political, economic, and social factors underlying and effecting religious change. Though these lines of scholarship have proven fruitful in many ways—not least in that they have given voice to previously marginalized groups, prioritized institutional histories, and recognized the social and political impact of religious ideas—they have too often understated or completely ignored the Bible’s central role in the “story” of the Reformation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#ntb-020",
      "id": "ap_ntb-020-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" Fortunately, recent developments in the field of Reformation studies indicate that attention to the Bible and its impact in the sixteenth century might be making a comeback. Among the most fruitful of these research trajectories are studies of the Bible that focus on its production and reception,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#ntb-021",
      "id": "ap_ntb-021-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" studies of early modern preaching,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#ntb-022",
      "id": "ap_ntb-022-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" studies of the doctrine "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_vm._v("of Scripture espoused by individual Reformers,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#ntb-023",
      "id": "ap_ntb-023-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" and studies in the history of biblical interpretation in the Reformation era."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#ntb-024",
      "id": "ap_ntb-024-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The present volume seeks to contribute to this growing scholarly literature devoted to the Bible and its reception, interpretation, and impact during the sixteenth-century Reformation. The nine chapters that follow originated as papers delivered at a conference titled “The Reformation and the Ministry of the Word,” held at Trinity Evangelical Divinity School (Deerfield, Illinois) in the fall of 2017 to commemorate the five hundredth anniversary of Martin Luther’s posting of the Ninety-Five Theses to the door of the Castle Church in Wittenberg. Because all the contributors to this volume are both active scholars and church leaders, their chapters explore the Bible’s decisive role in shaping early Protestant doctrine and practice in such a way as to encourage contemporary Protestants to celebrate their theological heritage and appropriate its riches.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("The Reformation and the Irrepressible Word of God ")]), _vm._v("is divided into four sections plus a concluding afterword. Section one explores the interpretation of the Bible in the Reformation. In "), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/p1chap1#chap-001"
    }
  }, [_vm._v("chapter one")]), _vm._v(", Scott M. Manetsch describes the important contribution of early Protestant biblical scholarship and interpretation, and then shows the pervasive—and skillful—use of Scripture among ordinary Protestants whose histories are reported in Jean Crespin’s famous "), _c('i', [_vm._v("History of the Martyrs ")]), _vm._v("(1570). In "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p1chap2#chap-002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter two")]), _vm._v(", David S. Dockery describes the development and substance of Luther’s distinctive christological interpretation of Scripture and then "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_vm._v("recommends its use to modern exegetes as a valuable canonical/theological principle in conjunction with the grammatical-historical method of interpretation.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In section two, attention is devoted to preaching and pastoral care in the Reformation. Michael A. G. Haykin’s chapter on Hugh Latimer demonstrates the strategic importance that preaching played in Latimer’s ministry as bishop of Worcester and chaplain to Edward VI as well as in the religious renewal of the English church. Next, in "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap2#chap-004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter four")]), _vm._v(", Ronald K. Rittgers offers a fascinating study of how early Protestants in their pastoral and devotional writings treated Scripture as a kind of sacrament or conduit of God’s grace that conveyed divine comfort, help, and wisdom to those who were afflicted of conscience or body. What this shows, Rittgers believes, is that early modern Protestants did not altogether “disenchant” the world, as some scholars have argued, but adopted forms of sacrality that were different from those popular in the medieval church. Hence, while the topic of the Protestant sacraments will not be addressed in detail in this volume, the sacramental nature of the Word is not entirely absent from the essays that follow.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Section three explores the doctrine of justification in the Reformation. In "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p3chap1#chap-005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter five")]), _vm._v(", Michael S. Horton demonstrates conclusively that Protestant reformers such as Luther, Calvin, and Peter Martyr Vermigli were not innovators in their interpretation of “justification passages” in Romans but instead followed an exegetical tradition derived from John Chrysostom (and other early Greek fathers), who recognized Paul’s antithesis between works of the law and faith, distinguished between justification and sanctification, and understood justification as a “great exchange” of the sinner’s guilt for Christ’s righteousness. If the Protestant doctrine of justification has deep historical roots, it also has continued relevance for people living in the contemporary world. Thus, in "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p3chap2#chap-006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter six")]), _vm._v(", Kevin DeYoung shows how the Pauline doctrine that sinners are both pardoned and accepted as righteous through faith in Christ is truly “good news” for modern men and women weighed down by the burden "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_vm._v("of guilt imposed by the Western secular world, with all its legalistic demands, intense suffering, and psychological angst.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The two chapters that make up section four address the Christian life in the Reformation. Thomas H. McCall’s chapter on Christian sanctification provides a timely reminder that, even as Luther and his Protestant colleagues affirmed that Christ, through his death, achieved the gracious justification of sinners, they also emphasized that Christ bestowed on believers the gift of the Holy Spirit, whose indwelling presence empowers them to grow in righteousness and holiness. Justification does not obviate the need for Christian holiness but rather makes it possible. Finally, in "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p4chap2#chap-008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter eight")]), _vm._v(", David J. Luy argues persuasively that Luther’s doctrine of the universal priesthood was not intended to displace ecclesial institutions or church hierarchies but was rather a constructive vision whereby Christians, as beneficiaries of God’s grace, become conduits of Christ and his life-giving benefits to the church. Thus, the universal ministry of God’s people is never divorced from Word and sacrament.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("The Reformation and the Irrepressible Word of God ")]), _vm._v("concludes with an afterword, written by Timothy George, that addresses the timely question “What can evangelicals learn from the Reformation?” Dr. George argues that the distinctive qualities of modern evangelicalism—conversion, the Bible, the cross, Christian activism—all find articulation and significant expression in the sixteenth-century Reformation. Evangelicalism will not endure as a religious movement if it does not remain firmly rooted in the Protestant heritage of the Reformation, with its commitment to God’s authoritative Word, its celebration of God’s gracious salvation through Jesus Christ, and its vision of the Christian church, renewed by the power of the Holy Spirit.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I would like to express my heartfelt gratitude to a number of different people who have made this book possible. First, I would like to thank the administration of Trinity Evangelical Divinity School, especially President David S. Dockery and Dean Graham Cole, for their consistent encouragement and financial support of the Reformation and the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_vm._v("Ministry of the Word Conference that was held on our campus in September 2017. I am also deeply grateful to my dear colleagues who so capably organized and implemented the Reformation conference, including Doug Sweeney, David Luy, Martin Klauber, Felix Theonugraha, Mark Kahler, Mary Guthrie, Chuck King, and Taylor Worley. Thank you to each one of you. A special word of appreciation is also in order to my research assistants, Taylor Sexton, Viktor Palenyy, and Caleb Jenkins, who improved the quality of this book by their careful editing work and by compiling the bibliography and index. In a similar fashion, I am also grateful to my friends at InterVarsity Press, especially associate editor David McNutt, for their support of this project and their meticulous labors bringing it to publication. Finally, I wish to thank the outstanding group of scholars who participated in the conference and contributed their essays to this volume. I am most grateful for your warm collegiality and friendship. May this book, in some small way, expand readers’ love for God and his Word, intensify their longing for renewal of Christ’s church, and permit them to exclaim (with Luther), “What great and glorious fruit the Word of God has produced!”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#ntb-025",
      "id": "ap_ntb-025-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Soli Deo gloria")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 66
// module chunks = 0